// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const CollateralDocumentCodeService = {};

CollateralDocumentCodeService.getCollateralDocumentCodeList = function (
  userInput
) {
  return lossClient({
    url: "/CollateralDocument/search?pageSize=1000&pageIndex=0&colldoctypeid=" +
      userInput.code,
    method: "get",
  });
};

export default CollateralDocumentCodeService;
